import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import { PreAuthorizationChargePayload } from 'models/securityDeposits/PreAuthorizations';
import API from 'services/API';

type UsePreAuthorizationChargeMutationArgs = PreAuthorizationChargePayload & {
  preAuthorizationUid: string;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    unknown,
    BaseErrorResponse,
    UsePreAuthorizationChargeMutationArgs
  >,
  'mutationFn' | 'mutationKey'
>;

const chargePreAuthorization = async ({
  preAuthorizationUid,
  ...payload
}: UsePreAuthorizationChargeMutationArgs) => {
  const response = await API.post(
    `/api/internal/security-deposit/pre-authorizations/${preAuthorizationUid}/charge`,
    payload,
  );
  return response.data;
};

const usePreAuthorizationChargeMutation = ({
  ...options
}: ReactQueryMutationOptions = {}) => {
  return useAppMutation({
    mutationFn: chargePreAuthorization,
    ...options,
  });
};

export default usePreAuthorizationChargeMutation;
